export default {
  'passReset.title': 'Şifre Değiştirildi!',
  'passReset.subtitle':
    'Hesap şifreniz başarıyla değiştirildi. Giriş yapmak için yeni şifrenizi kullanın.',
  'passReset.login': "Examod'a giriş yap",
  'passReset.goDashboard': 'Kullanıcı Paneline Git',
};
